import sample_1 from './climaSLang.jpg';

export const climaSLangImpressions = {
    sample_1,
};
